<template>
    <md-card-content>
        <p v-if="edit" class="font-medium mb-2">Ajout d'un ou plusieurs types d'intervention</p>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
                <div class="md-multiselect md-multiselect-multiple">
                    <label>Type d'intervention *</label>
                    <multiselect
	                    v-model="interventionGroup.types"
	                    :options="interventionTypes"
	                    :multiple="true"
	                    :close-on-select="false"
	                    :clear-on-select="false"
	                    :preserve-search="true"
	                    :show-labels="false"
	                    placeholder="Types d'interventions"
	                    label="name"
	                    track-by="id">
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                    <validation-error :errors="apiValidationErrors.intervention_types" />
                </div>
            </div>
        </div>
        <div class="md-layout md-gutter mt-4">
            <div class="md-layout-item md-size-50">
                <div class="md-multiselect md-multiselect-multiple">
                    <label>Mois d'intervention *</label>
                    <multiselect
	                    v-model="interventionGroup.months"
	                    :options="months"
	                    :multiple="true"
	                    :close-on-select="false"
	                    :clear-on-select="false"
	                    :preserve-search="true"
	                    :show-labels="false"
	                    placeholder="Mois d'intervention"
	                    label="label"
	                    track-by="label">
                        <template slot="noOptions">La liste est vide</template>
                        <template slot="noResult">Aucun élement correspondant</template>
                    </multiselect>
                    <validation-error :errors="apiValidationErrors.months" />
                </div>
            </div>
            <div class="md-layout-item md-size-50">
                <div class="md-vdatepicker">
                    <datetime
	                    v-model="interventionGroup.duration"
	                    type="time"
	                    auto
	                    max-datetime="11:00:00"
	                    min-datetime="00:00:00"
	                    input-id="duration"
	                    placeholder="HH:mm"
	                    :minute-step="5"
	                    :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }">
                        <label slot="before">Durée de l'intervention *</label>
                    </datetime>
                    <validation-error :errors="apiValidationErrors.duration" />
                </div>
            </div>
        </div>
    </md-card-content>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "InterventionGroupForm",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    props: {
        edit: Boolean,
        interventionGroup: {
            type: Object,
            default() {
                return {
                    types: [],
                    months: [],
                    duration: null
                }
            }
        },
        errors: Array,
        filteredInterventionTypes: Array
    },
    data() {
        return {
            interventionTypes: [],
            months: [
                { value: 0, label: 'Janvier' },
                { value: 1, label: 'Février' },
                { value: 2, label: 'Mars' },
                { value: 3, label: 'Avril' },
                { value: 4, label: 'Mai' },
                { value: 5, label: 'Juin' },
                { value: 6, label: 'Juillet' },
                { value: 7, label: 'Août' },
                { value: 8, label: 'Septembre' },
                { value: 9, label: 'Octobre' },
                { value: 10, label: 'Novembre' },
                { value: 11, label: 'Décembre' },
            ]
        }
    },
    methods: {
        async getInterventionTypes() {
            const { data } = await this.$store.dispatch('interventionTypes/getInterventionTypes')
            this.interventionTypes = data
        },
    },
    watch: {
        'filteredInterventionTypes'(newVal) {
            this.interventionTypes = newVal
        },
        'errors'(newVal) {
            this.resetApiValidation()
            if(newVal) {
                this.setApiValidation(newVal)
            }
        }
    },
    mounted() {
        if(this.filteredInterventionTypes) {
            this.interventionTypes = this.filteredInterventionTypes
        } else {
            this.getInterventionTypes()
        }
    }
}
</script>

<style scoped>

</style>
